import { defineGameCard } from '../authoring/index.js';
import { slimeDependencies, trail } from './slime-helpers.js';
export const AcidicSlimeCard = defineGameCard({
    id: 'acidic_slime',
    gameplay: { type: 'UNIT', cost: 1, baseStats: { attack: 2, health: 1 }, traits: ['SLIME'] },
    presentation: {
        name: 'Едкий слизень',
        description: 'След 1.',
        glyph: {
            colors: ['#10213A', '#74AD4C', '#96C653', '#5E984F', '#3A624D'],
            rows: [
                '....................',
                '....................',
                '....................',
                '....................',
                '......1111111.......',
                '.....1222233311.....',
                '....122233333331....',
                '....123333333331....',
                '...12233333333331...',
                '...12333333333331...',
                '..1333313333133341..',
                '..1333313333133341..',
                '..1333333333333341..',
                '..133333333333441...',
                '...13333333444551...',
                '....111444445511....',
                '.......1111111......',
                '....................',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: slimeDependencies(),
    abilities: [trail()],
    ui: { mechanics: ['trail', 'slime_residue'] },
});
//# sourceMappingURL=acidic_slime.js.map